import i18n from 'services/base/i18n';

export default {
  domain: () => i18n.pgettext('Components|List History|Filter History|Site Input|Domain Input', 'Enter Domain Name'),
};
